const mapboxToken =
  'pk.eyJ1IjoiZW5lcmxpbmtkZXYiLCJhIjoiY202Z3phcGVlMDc3NDJxcTV1MHd0eDVuMSJ9.DD6CFq30CpvWXk3UEVA9oQ';

export { mapboxToken };
